import React, { useState } from "react";
import axios from "axios";
import "../App.css";
import HomeButton from "./HomeButton";
import { useUser, useAuth } from "@clerk/clerk-react";
import { useNavigate } from "react-router-dom";

const API_URL = (process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:3001' : '')) + '/api';

const Pricing = () => {
  const { user, isSignedIn } = useUser();
  const { getToken } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    if (!isSignedIn) {
      // Als de gebruiker niet is ingelogd, stuur ze naar de login pagina
      navigate("/admin/login");
      return;
    }

    setLoading(true);
    try {
      const token = await getToken();
      const response = await axios.post(`${API_URL}/create-checkout-session`, {
        clerkId: user.id,
        email: user.primaryEmailAddress.emailAddress
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.url) {
        window.location.href = response.data.url;
      }
    } catch (error) {
      console.error("Stripe Checkout Error:", error);
      const message = error.response?.data?.error || "Er is iets misgegaan bij het starten van de betaling. Probeer het later opnieuw.";
      alert(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content-wrapper fade-in-up">
      <HomeButton />
      <h1 className="aharoni-style" style={{ fontSize: '3.5em', marginBottom: '20px' }}>Prijzen</h1>
      <p style={{ color: '#ccc', marginBottom: '40px' }}>Kies voor het pakket dat bij uw rijschool past.</p>
      
      <div className="admin-card" style={{ maxWidth: '400px', padding: '40px' }}>
        <h2 style={{ color: '#007bff' }}>Instructeurs Pakket</h2>
        <div style={{ margin: '20px 0' }}>
          <span style={{ fontSize: '3em', fontWeight: 'bold', color: '#fff' }}>€ 5,00</span>
          <span style={{ color: '#ccc' }}> / maand</span>
        </div>
        
        <ul style={{ listStyleType: 'none', padding: 0, textAlign: 'left', marginBottom: '30px', color: '#ccc' }}>
          <li style={{ marginBottom: '10px' }}>✓ Volledig agenda beheer</li>
          <li style={{ marginBottom: '10px' }}>✓ Eerste 15 dagen gratis</li>
          <li style={{ marginBottom: '10px' }}>✓ Kan opzeggen wanneer u wilt</li>
          <li style={{ marginBottom: '10px' }}>✓ Onbeperkt aantal leerlingen</li>
          <li style={{ marginBottom: '10px' }}>✓ Real-time synchronisatie</li>
          <li style={{ marginBottom: '10px' }}>✓ Feedback & Vragenlijsten</li>
          <li style={{ marginBottom: '10px' }}>✓ Support inbegrepen</li>
        </ul>

        <button 
          className="btn" 
          onClick={handleSubscribe} 
          disabled={loading}
          style={{ width: '100%', marginBottom: '20px' }}
        >
          {loading ? "Laden..." : (isSignedIn ? "Abonnement afsluiten" : "Inloggen & Starten")}
        </button>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginTop: '10px' }}>
          <span style={{ fontSize: '0.9em', color: '#888' }}>Veilig betalen met</span>
          <img 
            src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg" 
            alt="Stripe Logo" 
            style={{ height: '25px', filter: 'brightness(0) invert(1)', opacity: 0.7 }} 
          />
        </div>
      </div>
    </div>
  );
};

export default Pricing;
